import { actionTypes, mutationTypes, getterTypes } from './landing.moduletypes';

const actions = {
  [actionTypes.leaveComment]({ getters }, data) {
    return new Promise(resolve => {
      getters[getterTypes.LandingApi].leaveComment(data).then(result => {
        resolve(result);
      });
    });
  },
  [actionTypes.getHtmlContent]({ getters }, url) {
    return new Promise(resolve => {
      getters[getterTypes.LandingApi].getHtmlContent(url).then(result => {
        resolve(result);
      });
    });
  }
};

export default actions;
